'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: top;\n  width: 10%;\n  max-width: 44px;\n  line-height: 0;\n'], ['\n  display: inline-block;\n  vertical-align: top;\n  width: 10%;\n  max-width: 44px;\n  line-height: 0;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  width: 100%;\n  height: auto;\n  padding: 2px;\n\n  &:hover {\n    border: 1px solid orange;\n    background: lightgoldenrodyellow;\n    cursor: pointer;\n  }\n'], ['\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  width: 100%;\n  height: auto;\n  padding: 2px;\n\n  &:hover {\n    border: 1px solid orange;\n    background: lightgoldenrodyellow;\n    cursor: pointer;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _urijs = require('urijs');

var _urijs2 = _interopRequireDefault(_urijs);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Assets = require('./Assets');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var loadIcon = function loadIcon(view, selectedView) {
  return require('./img/' + view + '.' + (view === selectedView ? '' : 'un') + 'selected.png');
};

var resolve = function resolve(uri, baseUrl) {
  return (0, _urijs2.default)(uri).is('absolute') ? (0, _urijs2.default)(uri) : (0, _urijs2.default)(uri, baseUrl);
};

var IconWrapperDiv = _styledComponents2.default.div(_templateObject);

var IconImg = _styledComponents2.default.img(_templateObject2);

var Switcher = function Switcher(_ref) {
  var atlasUrl = _ref.atlasUrl,
      species = _ref.species,
      selectedView = _ref.selectedView,
      onChangeView = _ref.onChangeView;
  return _react2.default.createElement(IconWrapperDiv, null, (0, _Assets.getAnatomogramViews)(species).map(function (view) {
    return _react2.default.createElement(IconImg, {
      key: view,
      onClick: function onClick() {
        return onChangeView(view);
      },
      src: resolve(loadIcon(view, selectedView), atlasUrl).toString()
    });
  }));
};

Switcher.propTypes = {
  atlasUrl: _propTypes2.default.string.isRequired,
  species: _propTypes2.default.string.isRequired,
  selectedView: _propTypes2.default.string,
  onChangeView: _propTypes2.default.func.isRequired
};
Switcher.defaultProps = {
  atlasUrl: 'https://www.ebi.ac.uk/gxa/'
};
exports.default = Switcher;